import { loop, Cmd } from 'redux-loop';
import { Map } from 'immutable';
import * as USER_COMMANDS from 'ReduxLoop/user/userCommands';
import * as ACTIONS from 'ReduxLoop/user/userActions';
import { arrayToMap } from 'ReduxLoop/index';
import { addErrorNotification } from 'ReduxLoop/notifications/notificationActions';
import {
  SAVE_ORGANISATION_DETAILS_SUCCESS,
  SELECT_ORGANISATIONAL_UNIT,
} from 'ReduxLoop/ouManager/schoolManagerActions';
import {
  PERSIST_RESPONSIBILITIES_AND_REQUESTS_SUCCESS,
  PERSON_REFRESHED,
} from 'ReduxLoop/profile/profileActions';
import { PERSIST_NEW_TEAM_SUCCESS } from 'ReduxLoop/ouManager/createTeamWizard/createTeamWizardActions';
import {
  UPDATE_CONTACT_DETAIL_SUCCESS,
  REMOVE_CONTACT_DETAIL_SUCCESS,
} from '../ouManager/contactDetails/contactDetailsActions';
import { getKathOndvlaParents } from 'ReduxLoop/profile/profileCommands';
import * as PIWIK_ANALYTICS_ACTIONS from 'ReduxLoop/piwikAnalytics/piwikAnalyticsActions';

const inititalState = {
  user: null,
  bearerToken: null,
  logInCmd: null,
  isSuperAdmin: false,
  canDeleteKathOndVlaOus: false,
  adminForOuTypes: new Set(),
  ousWithReadAccessToResps: [],
  ousWithAccessToInvitations: [],
  ousWithUpdateAccessToResps: [],
  ousWithAccessToAccountingDetails: [],
  ousWithGrantAccessToSensitiveInformation: [],
  popUpIsOpened: false,
  positions: null,
  // studyProgrammes: null,
  responsibilities: null,
  ous: null,
  dienstParentRelations: null,
  parentRelations: Map(),
  campusses: Map(),
  ouContactDetails: Map(),
  ouContactDetailsFetched: false,
  institutionNumbers: {},
  educationLevels: null, // educationLevels is an alrady calculated simplification of mainstructures, but because of the complexity it is much easier to keep both representaitons
  mainstructures: {},
  userDidSkipContactDetailsModal: false,
  modalMissingInformationIsOpened: false,
};

export const userReducer = (state = inititalState, action) => {
  switch (action.type) {
    case ACTIONS.FETCH_USER:
      if (state.user && !action.payload) {
        return state;
      }
      return loop(
        state,
        Cmd.run(USER_COMMANDS.getUser, {
          args: [],
          successActionCreator: ACTIONS.userFetched,
        })
      );

    case ACTIONS.USER_FETCHED:
      return loop(
        { ...state, user: action.payload },
        Cmd.list([
          Cmd.run(USER_COMMANDS.getUserResponsibilities, {
            args: [action.payload],
            successActionCreator: ACTIONS.userResponsibilitiesFetched,
            failActionCreator: ACTIONS.fetchUserResponsibilitiesFailed,
          }),
          Cmd.run(USER_COMMANDS.getUserLoginMethod, {
            args: [action.payload],
            successActionCreator: ACTIONS.userLoginMethodFetched,
            failActionCreator: ACTIONS.userLoginMethodFailed,
          }),
          Cmd.run(USER_COMMANDS.identifyUserInLogRocket, { args: [action.payload] }),
        ])
      );

    case ACTIONS.ON_USER_IS_NOT_LOGGED_IN: {
      if (state.logInCmd) {
        return loop(state, Cmd.list([state.logInCmd]));
      }
      return loop(state, Cmd.run(USER_COMMANDS.goToOauthLoginScreen));
    }

    case ACTIONS.SET_LOG_IN_CMD: {
      return { ...state, logInCmd: action.payload };
    }

    case PERSON_REFRESHED: {
      if (state.user && action.payload.key === state.user.key) {
        return { ...state, user: action.payload };
      }
      return state;
    }

    case ACTIONS.FETCH_USER_RESPONSIBILITIES_FAILED:
    case ACTIONS.USER_LOGIN_METHOD_FAILED:
    case ACTIONS.USER_TARGET_GROUP_FAILED: {
      console.error(`SEVERE ERROR: ${action.type.toUpperCase()}`, action.payload);
      const addError = addErrorNotification(
        'Er is een onbekende fout opgetreden bij het ophalen van jouw gegevens.'
      );
      return loop(state, Cmd.action(addError));
    }

    case ACTIONS.USER_RESPONSIBILITIES_FETCHED: {
      const ous = arrayToMap([...action.payload.samOus, ...action.payload.kathOndVlaOus])
      return loop(
        {
          ...state,
          responsibilities: action.payload.userResponsibilities,
          ous,
          isSuperAdmin: action.payload.isSuperAdmin,
          canDeleteKathOndVlaOus: action.payload.canDeleteKathOndVlaOus,
          adminForOuTypes: action.payload.adminForOuTypes,
          ousWithReadAccessToResps: action.payload.ousWithReadAccessToResps,
          ousWithAccessToInvitations: action.payload.ousWithAccessToInvitations,
          ousWithUpdateAccessToResps: action.payload.ousWithUpdateAccessToResps,
          ousWithGrantAccessToSensitiveInformation:
            action.payload.ousWithGrantAccessToSensitiveInformation,
          ousWithAccessToAccountingDetails: action.payload.ousWithAccessToAccountingDetails,
          parentRelations: Map(arrayToMap(action.payload.groupParentRelations)),
        },
        Cmd.list([
          Cmd.run(USER_COMMANDS.getAllContactDetails, {
            args: [Object.values(ous)],
            successActionCreator: ACTIONS.userOuContactDetailsFetched,
          }),
          Cmd.run(getKathOndvlaParents, {
            args: [ous],
            successActionCreator: ACTIONS.kathOndVlaParentsFetched,
          }),
        ])
      );
    }

    case ACTIONS.USER_LOGIN_METHOD_FETCHED: {
      const newState = { ...state };
      newState.user.userLoginMethod = action.payload;
      return newState;
    }

    case ACTIONS.USER_TARGET_GROUP_FETCHED: {
      const newState = { ...state };
      newState.user.userTargetGroup = action.payload;
      return loop(newState, Cmd.action(PIWIK_ANALYTICS_ACTIONS.trackPiwikEvent('view_page')));
    }

    case ACTIONS.KATHONDVLA_PARENTS_FETCHED:
      const newOus = { ...state.ous, ...arrayToMap(action.payload.parentOus) };
      return loop(
        {
          ...state,
          ous: newOus,
          dienstParentRelations: action.payload.parentRelations,
        },
        Cmd.list([
          Cmd.run(USER_COMMANDS.getInstitutionNumbersAndEducationLevels, {
            args: [Object.values(newOus)],
            successActionCreator: ACTIONS.institutionNumbersAndEducationLevelsFetched,
          }),
          Cmd.run(USER_COMMANDS.calculateUserTargetGroup, {
            args: [
              state.responsibilities,
              newOus,
              action.payload.parentRelations,
            ],
            successActionCreator: ACTIONS.userTargetGroupFetched,
            failActionCreator: ACTIONS.userTargetGroupFailed,
          })
        ])
      );

    case ACTIONS.USER_OU_CONTACTDETAILS_FETHED:
      return {
        ...state,
        ouContactDetails: Map(arrayToMap(action.payload)),
        ouContactDetailsFetched: true,
      };

    case ACTIONS.INSTITUTION_NUMBERS_AND_EDUCATION_LEVELS_FETCHED: {
      return {
        ...state,
        institutionNumbers: action.payload.institutionNumbers,
        educationLevels: action.payload.educationLevels,
        mainstructures: action.payload.mainstructures,
      };
    }

    case ACTIONS.FETCH_POSITIONS:
      if (state.positions) {
        return state;
      }
      return loop(
        state,
        Cmd.run(USER_COMMANDS.getPositions, {
          successActionCreator: ACTIONS.positionsFetched,
        })
      );

    case ACTIONS.POSITIONS_FETCHED: {
      return { ...state, positions: Map(arrayToMap(action.payload)) };
    }

    case ACTIONS.LOG_OUT:
      return loop(inititalState, Cmd.run(USER_COMMANDS.doLogOut));

    case ACTIONS.POP_UP_IS_OPENED: {
      return { ...state, popUpIsOpened: true };
    }

    case SAVE_ORGANISATION_DETAILS_SUCCESS: {
      const newOus = { ...state.ous };
      newOus[action.payload.$$meta.permalink] = action.payload;
      return { ...state, ous: newOus };
    }

    case PERSIST_RESPONSIBILITIES_AND_REQUESTS_SUCCESS: {
      if (action.payload.deactivatedResponsibilities.length === 0) {
        return state;
      }
      let newResps = state.responsibilities;
      action.payload.deactivatedResponsibilities.forEach((href) => {
        newResps = newResps.filter((resp) => resp.$$meta.permalink !== href);
      });
      return { ...state, responsibilities: newResps };
    }

    case PERSIST_NEW_TEAM_SUCCESS: {
      const newResps = [...state.responsibilities, action.payload.responsibility];
      const newOus = { ...state.ous };
      newOus[action.payload.organisation.$$meta.permalink] = action.payload.organisation;
      return {
        ...state,
        responsibilities: newResps,
        ous: newOus,
      };
    }

    case ACTIONS.USER_DID_SKIP_CONTACT_DETAILS_MODAL: {
      return { ...state, userDidSkipContactDetailsModal: true };
    }

    case ACTIONS.MODAL_MISSING_INFORMATION_IS_OPENED: {
      return { ...state, modalMissingInformationIsOpened: true };
    }

    case SELECT_ORGANISATIONAL_UNIT: {
      return { ...state, modalMissingInformationIsOpened: false };
    }

    case UPDATE_CONTACT_DETAIL_SUCCESS: {
      return {
        ...state,
        ouContactDetails: state.ouContactDetails.set(
          action.payload.contactDetail.$$meta.permalink,
          action.payload.contactDetail
        ),
      };
    }

    case REMOVE_CONTACT_DETAIL_SUCCESS: {
      return {
        ...state,
        ouContactDetails: state.ouContactDetails.delete(
          action.payload.contactDetail.$$meta.permalink
        ),
      };
    }

    default:
      return state;
  }
};